import { Project } from 'src/store/state/projects';

export const getAllProjectNamespaces = (modelsById: Project['modelsById']) =>
  Object.values(modelsById).reduce<Record<string, string>>(
    (acc, model) => ({
      ...acc,
      ...model.databaseNamespaces,
    }),
    {}
  );
